import type { IHomeLocation } from '@/domain/entities/home-location';
import type { IHomeSystem } from '@/domain/entities/system';
import type { IUtility } from '@/domain/entities/utility';

export type ApiAuthMode = 'required' | 'none';

export interface ApiRequestOptions extends RequestInit {
  authMode?: ApiAuthMode;
  /** Avoid request/response payload logging for sensitive workflows. */
  suppressLogging?: boolean;
}

export interface IApiService {
  get<T>(url: string, init?: ApiRequestOptions): Promise<T>;
  post<T, B = unknown>(url: string, body?: B, init?: ApiRequestOptions): Promise<T>;
  put<T, B = unknown>(url: string, body?: B, init?: ApiRequestOptions): Promise<T>;
  patch<T, B = unknown>(url: string, body?: B, init?: ApiRequestOptions): Promise<T>;
  delete<T>(url: string, init?: ApiRequestOptions): Promise<T>;
}

export const ResponseMessages = {
  NotFoundCode: 'NotFound',
  InvalidArgsCode: 'InvalidArgs',
} as const;

export interface CreateItemResponse<T> {
  message: string;
  data: T;
}

export interface DeleteSchemaResponse {
  message: string;
  data: {
    id: string;
    ok: boolean;
    version: string;
  };
}

export type PaginatedListResponse<TItem> = {
  items: TItem[];
  limit: number;
  total: number;
  nextToken?: string | null;
};

export type ListLocationsResponse = PaginatedListResponse<IHomeLocation>;
export type ListSystemsResponse = PaginatedListResponse<IHomeSystem>;
export type ListUtilitiesResponse = PaginatedListResponse<IUtility>;
